var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-container",on:{"touchstart":_vm.startDrag,"mousedown":_vm.startDrag,"touchmove":_vm.onDrag,"mousemove":_vm.onDrag,"mouseup":_vm.endDrag,"touchend":_vm.endDrag}},[_c('div',{ref:"wrap",staticClass:"mint-tab-container-wrap"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }